import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmployeeLeavingRequestDTO, EmployeeOverviewView } from '@iota/inh-core-v1-management-client';

@Component({
    standalone: false,
    selector: 'app-employee-leaving-dialog-validation-data',
    templateUrl: './employee-leaving-dialog-validation-data.component.html',
    styleUrls: ['./employee-leaving-dialog-validation-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeeLeavingDialogValidationDataComponent {
    @Input() leavingRequest: EmployeeLeavingRequestDTO;
    @Input() employee: EmployeeOverviewView;
    @Input() officeIdToNameMap: Map<string, string>;

    get employeeOfficeName() {
        return this.officeIdToNameMap?.get(this.employee?.officeId);
    }
}
